import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PercentIndicatorDiv } from './percent-indicator-div/percent-indicator-div.component';
import { ContactsAddPersonComponent } from './contacts-add-person/contacts-add-person.component';
import { DeletePopupComponent } from './delete-popup/delete-popup.component';
import { ContactsDropdownBoxComponent } from './contacts-dropdown-box/contacts-dropdown-box.component';
import { LoggingPopupComponent } from './logging-popup/logging-popup.component';


@NgModule({
  imports: [
    CommonModule,

  ],
  declarations: [
    PercentIndicatorDiv,

  ],
  exports: [
    PercentIndicatorDiv,

  ]
})
export class SharedComponentsModule { }